<template>
    <span class="flex items-center gap-1" :class="classes">
        <i
            class="fas fa-exclamation-circle"
            v-if="isLate"
        ></i>
        <span>
            {{ text }}
        </span>
    </span>
</template>

<script>
    export default {
        props: {
            task: {
                type: Object,
                required: true
            },
            className: {
                type: String,
                default: ''
            },
            emptyText: {
                type: String,
                default: '-'
            }
        },
        computed: {
            text() {
                const { due_date } = this.task;

                if ( ! due_date ) {
                    return this.emptyText;
                }

                const now = this.$moment();
                const dueDate = this.$moment(due_date);

                if ( dueDate.isSame(now, 'day') ) {
                    return this.$t('date.today');
                }

                if ( dueDate.isSame(now.clone().subtract(1, 'days'), 'day') ) {
                    return this.$t('date.yesterday');
                }

                if ( dueDate.isSame(now.clone().add(1, 'days'), 'day') ) {
                    return this.$t('date.tomorrow');
                }


                return dueDate.format('DD MMM YYYY');
            },
            isToday() {
                return this.task.due_date && ! this.task.done_at ?
                    this.$moment(this.task.due_date).isSame(this.$moment(), 'day')
                    : false;
            },
            isLate() {
                return this.task.due_date && ! this.task.done_at ?
                    this.$moment(this.task.due_date).isBefore(this.$moment(), 'day')
                    : false;
            },
            classes() {
                return [
                    this.className,
                    {
                        'text-green-500': this.isToday,
                        'text-red-500': this.isLate
                    }
                ]
            }
        }
    }
</script>